// extracted by mini-css-extract-plugin
export default {"page":"login_page__+fHSA"};